export default "__VITE_ASSET__OoCUZ_EQ__"